import { ANALYSIS_NOTIFICATION_STORAGE_KEY_PREFIX } from "./consts";

export const getAnalysisNotificationStorageKey = (url: string) =>
  `${ANALYSIS_NOTIFICATION_STORAGE_KEY_PREFIX}${url}`;
